import {createApi} from "@reduxjs/toolkit/query/react";
import {Response} from "../../types/response/Response";
import {apiQueryV2} from "../utils/Extensions";
import {Courier, CourierDTO, CouriersGetRequestBody} from "../../types/courier/CourierDTO";
import {toCourier} from "../../utils/constants/Courier";


export const courierApi = createApi({
    reducerPath: "courier",
    baseQuery: apiQueryV2,
    tagTypes: ["couriers"],
    endpoints: builder => ({
        getCouriers: builder.query<Response<Courier[]>, Partial<CouriersGetRequestBody>>({
            query: ({
                        branchId,
                        isActive = true
                    }) => `/organizations/${branchId}/couriers?isActive=${isActive}`,
            transformResponse: (response: Response<CourierDTO[]>) => {
                const receivedAtMs = Date.now()
                return {...response, data: response.data?.map(courier => toCourier(courier, receivedAtMs)) ?? null}
            },
            providesTags: ["couriers"],
            extraOptions: {maxRetries: 3}
        })
    })
})

export const {
    useGetCouriersQuery,
    useLazyGetCouriersQuery
} = courierApi